<template>
  <div class="home" style="margin-bottom:51px !important;
    overflow: scroll;    margin-top: -11px;">
   
    <wish></wish>
  </div>
  
  
</template>

<script>
// @ is an alias to /src
// import offr from '@/components/Items'
import wish from '@/components/wishlis'
import axios from 'axios';

export default {
   components: {      
        // offr,
        wish,
        
       },
        data: () => ({
            name: 'Wishlist',
            products : []
        }),
        mounted() {
           this.getItems();
            this.$parent.$children[0].$parent.ttlval = this.name

            // console.log(this.$el.textContent) 

       },
    methods: {
    getItems: function () {
      // this.loading = true;
      axios.get(this.$bURL+"item/GetItemDetailsList?Category=Bottles&SubCategory=All")
      .then((response)  =>  {
        // this.loading = false;
        // console.log(response)
        // this.products = response.data;
      }, (error)  =>  {
          console.log(error)
      })
    }
  },

 
}
</script>
